import React from "react";

export default function PremierIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <g clip-path="url(#clip0_627_499)">
        <g filter="url(#filter0_d_627_499)">
          <path
            d="M10.0279 9.10306C10.0279 11.5877 8.01372 13.6019 5.52909 13.6019C3.04446 13.6019 1.03027 11.5877 1.03027 9.10306C1.03027 6.61843 3.04446 4.60425 5.52909 4.60425C8.01372 4.60425 10.0279 6.61843 10.0279 9.10306Z"
            fill="#22252E"
          />
        </g>
        <path
          d="M3.95734 6.63519C4.29668 6.57477 4.75684 6.52979 5.37511 6.52979C6.05379 6.52979 6.5448 6.67375 6.86871 6.94496C7.17078 7.19432 7.36615 7.59408 7.36615 8.06838C7.36615 8.54268 7.21577 8.94372 6.93555 9.21493C6.55894 9.58512 5.98566 9.76507 5.32884 9.76507C5.15531 9.76507 5.00492 9.75736 4.87638 9.7278V11.6507H3.95605V6.6339L3.95734 6.63519ZM4.87767 8.99642C4.99849 9.0337 5.14117 9.04141 5.33012 9.04141C6.02422 9.04141 6.44711 8.69436 6.44711 8.10566C6.44711 7.51695 6.05507 7.24574 5.41367 7.24574C5.15659 7.24574 4.97664 7.26888 4.87767 7.29073V8.99514V8.99642Z"
          fill="white"
        />
        <path
          d="M5.94054 0C10.7234 0.00257075 14.6014 3.88183 14.6014 8.666C14.6014 9.05547 13.7441 9.05547 13.7441 8.666C13.7441 4.20446 10.4008 0.859916 5.94054 0.858631C5.55107 0.858631 5.55107 0 5.94054 0Z"
          fill="#43BA32"
        />
        <path
          d="M5.94054 1.5271C9.88022 1.52838 13.0744 4.72511 13.0744 8.66607C13.0744 9.05554 12.217 9.05554 12.217 8.66607C12.217 5.04774 9.55759 2.38702 5.94054 2.38573C5.55107 2.38573 5.55107 1.5271 5.94054 1.5271Z"
          fill="#43BA32"
        />
        <path
          d="M5.94054 3.07202C9.02801 3.07202 11.5306 5.57722 11.5306 8.66469C11.5306 9.05416 10.672 9.05416 10.672 8.66469C10.672 5.89985 8.7041 3.93065 5.94054 3.92937C5.55107 3.92937 5.55107 3.07202 5.94054 3.07202Z"
          fill="#43BA32"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_627_499"
          x="-0.911255"
          y="2.66272"
          width="12.8811"
          height="12.8806"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.970764" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.988235 0 0 0 0 0.980392 0 0 0 0 0.988235 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_627_499"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_627_499"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_627_499">
          <rect width="14.616" height="14.616" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
